angular.module("componentes").directive("completeSignUpForm", [
	function () {
		"use strict";
		return {
			scope: {},
			controller: "CompleteSignUpFormCtrl",
			controllerAs: "ctrl",
			templateUrl: "views/register/components/completeSignUpForm_template.html"
		};
	}
]);
